import React from 'react';
import PropTypes from 'prop-types';
import getImageStyle from 'utils/getImageStyle';

import SimpleButton from 'styled/Buttons/SimpleButton';
import Content from 'components/ConfirmModal/Content';
import ConfirmModal from 'components/ConfirmModal';

import Image from './Image';
import ZoomImage from './ZoomImage';

class PhotoZoom extends React.PureComponent {
  state = {
    isOpen: false,
  }

  handleClick = () => {
    this.setState({ isOpen: true });
  }

  handleClose = () => {
    this.setState({ isOpen: false });
  }

  render() {
    return (
      <React.Fragment>
        <SimpleButton type="button" onClick={this.handleClick} style={{ marginRight: '16px' }}>
          <Image src={getImageStyle(this.props.src, '144x88')} alt={this.props.alt} />
        </SimpleButton>

        <ConfirmModal onClose={this.handleClose} isOpen={this.state.isOpen} styles={{ width: 'auto' }}>
          <Content>
            <ZoomImage src={this.props.src} alt={this.props.alt} />
          </Content>
        </ConfirmModal>
      </React.Fragment>
    );
  }
}

PhotoZoom.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
};

PhotoZoom.defaultProps = {
  src: '',
  alt: '',
};

export default PhotoZoom;
